<!-- 报告上传 -->

<template>
  <div class="province-9">
    <div class="ttBar">
      <span>出版连续型电子出版物单位上报</span>
    </div>
    <div class="pgContent">
      <el-upload
        v-if="ableUp == 1"
        disabled="upState == 'loading'"
        ref="upload"
        accept=".doc,docx"
        :disabled="upState == 'loading'"
        :action="postUrl"
        :before-upload="prevCtrls"
        :on-progress="pgressCtrls"
        :on-error="errorCtrls"
        :on-success="successCtrls"
        :on-remove="removeCtrls"
        :show-file-list="false"
        :data="fileData"
        multiple
        :on-exceed="handleExceed">
        <el-button>
          <span v-if="upState == 'loaded'">更新分析报告</span>
          <span v-else-if="upState == 'loading'">上传中 <i class="el-icon-loading"></i></span>
          <span v-else>上传分析报告</span>
        </el-button>
      </el-upload>

      <div v-if="ableUp == 1" class="flieList">
        <a :href="fileUrl" download>{{ fileName }}</a>
      </div>

      <el-button v-if="ableUp == 2">
        <a :href="fileUrl" download>下载分析报告</a>
      </el-button>

      <div>
        <el-progress
          class="progressBox"
          v-show="upState == 'loading'"
          :stroke-width="9"
          :percentage="percentage"></el-progress>
      </div>

      <div v-if="ableUp == 3" class="pvcTips">已上报至总局</div>
    </div>
    <div v-if="ableUp == 1" class="subArea">
      <el-button @click="goAdmin" type="primary">上报国家新闻出版署</el-button>
    </div>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import {
  stepToAdmin,
  isSubmited,
  successiveReported,
  ssReportLoad,
  ssReportUpload,
} from "@/api/provinceRole/provinceRole";
import { getFileToken } from "@/api/account";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      percentage: 0,
      upState: "wait",
      fileData: {},
      imgUrl: "",
      fileToken: "",
      ableUp: 0,
      reportId: "",

      fileUrl: "",
      fileName: "",
      postUrl: "",
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
    prevCtrls: function (file) {
      let nameArr = file.name.split(".");
      let fileType = nameArr[nameArr.length - 1];

      if (fileType != "doc" && fileType != "docx") {
        this.$message({
          message: "请上传格式为 WORD 的文件！",
          type: "error",
        });
        return false;
      }

      if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: "文件大小不能超过 10M！",
          type: "error",
        });
        return false;
      } else {
        this.percentage = 0;
        this.upState = "loading";
        this.fileData.token = getToken();
        this.fileData.fileSize = file.size;
        return true;
      }
    },
    pgressCtrls: function (evt, file) {
      this.percentage = parseInt(file.percentage);
    },
    errorCtrls: function (err) {
      this.upState = "wait";
      this.$alert("上传失败，请稍后重试！", "提示", {
        confirmButtonText: "确定",
        type: "error",
      });
    },

    successCtrls: function (data, file) {
      let vm = this;
      this.percentage = 99;
      let newDate = new Date();
      let yearStr = newDate.getFullYear() - 2 + "-" + (newDate.getFullYear() - 1);

      ssReportUpload({
        provinceReport: {
          reportId: data.payload.id,
          year: yearStr,
          type: 3,
          status: this.ableUp,
        },
      })
        .then((response) => {
          this.percentage = 100;
          this.upState = "loaded";
          this.$refs.upload.clearFiles();

          this.fileUrl =
            process.env.BASE_API + "/File/File/download/token/" + this.fileToken + "/id/" + data.payload.id;
          this.fileName = file.name;

          this.$emit("go-frash");
        })
        .catch((error) => {
          this.$refs.upload.clearFiles();
          this.upState = "wait";
        });
    },

    goAdmin: function () {
      stepToAdmin({ type: 3 }).then((response) => {
        this.ableUp = 2;
        this.$message.success("提交成功！");
      });
    },

    goFirmSeek: function () {
      let promiseArr = [];
      let vm = this;

      promiseArr.push(
        new Promise((resolve, reiect) => {
          successiveReported({ type: 3 })
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reiect(error);
            });
        })
      );

      promiseArr.push(
        new Promise((resolve, reiect) => {
          ssReportLoad({ type: 3, provinceId: this.userInfo.orgId })
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reiect(error);
            });
        })
      );

      promiseArr.push(
        new Promise((resolve, reiect) => {
          getFileToken()
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reiect(error);
            });
        })
      );

      Promise.all(promiseArr).then((result) => {
        let isPosted = false;
        let isUpload = false;

        vm.fileToken = result[2].resultStatus.token;

        if (result[0].status == 2) {
          isPosted = true;
        }

        if (result[1].provinceReport) {
          isUpload = true;
          vm.fileUrl =
            process.env.BASE_API +
            "/File/File/download/token/" +
            vm.fileToken +
            "/id/" +
            result[1].provinceReport.reportId;
          vm.fileName = result[1].provinceReport.fileName;
        }

        if (isPosted) {
          if (isUpload) {
            vm.ableUp = 2;
          } else {
            vm.ableUp = 3;
          }
        } else {
          vm.ableUp = 1;
          if (isUpload) {
            vm.upState = "loaded";
          }
        }
      });
    },
  },

  created: function () {
    this.goFirmSeek();
    this.postUrl = process.env.BASE_API + "/File/File/upload";
    // console.log(this.userInfo);
  },
};
</script>

<style lang="scss">
.province-9 {
  padding: 9px;
  .ttBar {
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    font-size: 14px;
    padding: 0px 20px;
    color: #666666;
    font-weight: bold;
  }
  .pgContent {
    padding: 20px;
    border-bottom: 1px solid #e8e8e8;

    .el-button {
      width: 168px;
    }

    .progressBox {
      width: 60%;
      margin-top: 12px;
    }

    .flieList {
      font-size: 14px;
      margin-top: 12px;

      a {
        color: #409eff;
      }
    }
  }
  .subArea {
    padding: 20px;
  }
  .pvcTips {
    padding: 12px 20px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// successiveReport.vue?f884ff84